import {
  buildWhatsAppLegacyPayload,
  formatWhatsAppPhone,
  sanitizeWhatsAppText,
  sendCurrentWhatsAppMessage,
} from './sendWhatsAppCurrent'
import { createStoreOrderConfirmedTemplateParams, WHATSAPP_TEMPLATES } from './whatsappTemplates'

export default async function sendWsStore(order) {
  const recipient = formatWhatsAppPhone(order.orderNote.store.phone)

  try {
    await sendCurrentWhatsAppMessage({
      to: recipient,
      template: WHATSAPP_TEMPLATES.STORE_ORDER_CONFIRMED,
      params: createStoreOrderConfirmedTemplateParams({
        storeName: sanitizeWhatsAppText(order.orderNote.store.name),
        orderNumber: sanitizeWhatsAppText(order.orderNote.number),
      }),
    })

    return buildWhatsAppLegacyPayload(recipient, true)
  } catch (error) {
    return buildWhatsAppLegacyPayload(
      recipient,
      false,
      error.message || 'No fue posible enviar la confirmación del pedido por WhatsApp.',
    )
  }
}
